<template>
    <eventi-edit-component :jsonData="jsonData" :utente="utente" :pathResource="pathResource" :titoloEvento="titoloEvento" @update="onUpdateJsonData" :isAllegati="true" :isMateriali="true">
        <template slot="tab-content-event">
            <visita-botox-edit-component :jsonData="jsonData" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></visita-botox-edit-component>
        </template>
    </eventi-edit-component>
</template>
<script>
import EventiEditComponent from "../../../base/components/EventiEditComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
import UtilityMixin from "../../../../../utility/UtilityMixin";
import VisitaBotoxEditComponent from "../components/VisitaBotoxEditComponent.vue";
export default {
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    mixins: [UtilityMixin],
    components: { EventiEditComponent, VisitaBotoxEditComponent },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
        linkPatient() {
            return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
        },
    },
    mounted() {
        this.jsonData.dataEvento = new Date().getTime();
    },
    data() {
        return {
            linkback: null,
            titoloEvento: "Visita Botox",
            pathResource: "/visitabotox",
            pathRestValidation: "/validation",
            id: "-1",
            isFirmato: false,
            childKey: 0,
            tabIndex: 0,
            showModalLoading: false,
            jsonData: {
                dataEvento: new Date().getTime(),
                note: "",
                idPrenotazione: "",
                idPrestazione: "",
                prestazione: "",
                prezzoPrestazione: 0,
                diagnosi: "",
                categoriaDiagnosi: "",
                diagnosiAltro: "",
                fiala: "",
                fialaDescrizione: "",
                tipoTrattamento: "",
                fialaQuantita: 0,
                fialaPrezzo: 0,
                listaPrestazioni: [{ categoriaDiagnosi: "", diagnosi: "", diagnosiAltro: "", tipoTrattamento: "", prestazione: "", prezzoPrestazione: 0, prestazioneFattura: "", fiala: "", fialaDescrizione: "", fialaQuantita: 0, fialaPrezzo: 0 }],
            },
        };
    },
    methods: {
        onFirmaUpdate() {
            let me = this;
            me.loadData();
        },
        onUpdateFile() {
            let me = this;
            me.childKey++;
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
    },
};
</script>
